import { Component, Vue } from 'vue-property-decorator';
import { AutocompleteDTO } from '../../../../../client-generator/generated-clients/billing';
import { RealEstateSiteDTO } from '../../../../../client-generator/generated-clients/real-estate';
import realEstateClient from '../../../../core/api/real-estate-service';
import sitesClient from '../../../../core/api/sites-service';

type RealEstateSiteWithParsedExtra = RealEstateSiteDTO & {
  parsedOtherFields?: { [k: string]: string | undefined } | undefined;
};

@Component({})
export default class RealEstateRegistryFlatView extends Vue {
  isLoading = false;
  places: AutocompleteDTO[] = [];

  selectedPlace = '';
  commonOtherFields: string[] = [];
  filteredBuildings: RealEstateSiteWithParsedExtra[] = [];

  private jobTask!: string;
  private buildings: RealEstateSiteWithParsedExtra[] = [];

  async mounted() {
    this.jobTask = this.$route.query.jobTask as string;
    if (!this.jobTask) throw new Error(`Missing job task id`);

    this.isLoading = true;
    await this.fetchData();
    this.isLoading = false;
  }

  get tableHeight() {
    return window.innerHeight - 250;
  }

  backToList() {
    this.$router.back();
  }

  handlePlaceChange(id: string) {
    this.filteredBuildings = this.buildings.filter((b) => b.codiceUbicazione === id);
  }

  doCleanup() {
    this.filteredBuildings = [...this.buildings];
  }

  private async fetchData() {
    this.places = await sitesClient.customerAutocomplete(this.jobTask, undefined);
    if (this.places.length >= 1) this.selectedPlace = undefined!;
    this.buildings = await realEstateClient.sitesBuildings(this.jobTask);
    this.buildings.forEach((b) => {
      b.parsedOtherFields = {};
      b.otherFields!.forEach((k) => {
        if (!this.commonOtherFields.find((f) => k.label === f)) this.commonOtherFields.push(k.label!);

        b.parsedOtherFields![k.label!] = k ? `${k.value}${k.unitOfMeasure ?? ''}` : undefined;
      });
      return b;
    });
    this.filteredBuildings = [...this.buildings];
  }
}
